import React from "react";
import {
  getStatusBackground,
  getStatusTextColor,
  getStatusDotColor,
  destructStatusData,
} from "../../../utils/statusConstants";

// Chip for patient / visit / order statuses (hex dot colour)
const StatusChip = ({ status }: { status?: string }) => {
  if (!status) return <span className="text-neutral-90 font-normal">-</span>;
  return (
    <span
      style={{
        color: getStatusTextColor(status),
        background: getStatusBackground(status),
        borderRadius: "46px",
        padding: "4px 12px",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "12px",
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          background: getStatusDotColor(status),
        }}
      />
      {destructStatusData(status)}
    </span>
  );
};

export default StatusChip;
